import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';

const requireAuth = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  // Renews an expired access token instead of sending a working user to the login page.
  return auth.ensureAuthenticated().pipe(
    map((authenticated) => authenticated ? true : router.createUrlTree(['/login'])),
  );
};

export const authGuard: CanActivateFn = () => requireAuth();
export const authChildGuard: CanActivateChildFn = () => requireAuth();
